var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { GridHeaderCell } from './GridHeaderCell';
export function gridHeaderCell(config) {
    return function headerCellRenderer(_a) {
        var column = _a.column, cellIndex = _a.cellIndex, className = _a.className, _b = _a.handlers, handlers = _b === void 0 ? {} : _b;
        return (React.createElement(GridHeaderCell, __assign({ text: config.title, justify: column.justify, className: className, columnWidth: column.width, key: "header-cell-" + cellIndex + "-" + column.id, sorting: config.sorting, tooltipMaxWidth: config.tooltipMaxWidth ? config.tooltipMaxWidth + "px" : '', onClick: config.onClick }, handlers)));
    };
}
//# sourceMappingURL=cell.js.map